/* NOVAIRE mega menu — hover/focus intent with the design system's timing.
   Triggers are nav links with [data-nv-mega-trigger]; each panel
   [data-nv-mega] sits adjacent to its trigger inside [data-nv-header], so
   keyboard focus reaches a panel before the next trigger. Desktop only
   (panels are display:none under 900px, where the nav wraps instead).
   Re-inits on theme editor section loads; block select/deselect keeps a
   panel open while the merchant edits its settings. */
(function () {
  'use strict';

  var CLOSE_DELAY = 150; /* --nv-duration-fast */
  var header = null;
  var closeTimer = null;
  var openHandle = null;
  var designSelected = false;

  function trigger(handle) {
    return header && header.querySelector('[data-nv-mega-trigger="' + handle + '"]');
  }
  function panel(handle) {
    return header && header.querySelector('[data-nv-mega="' + handle + '"]');
  }

  function setOpen(handle, open) {
    var t = trigger(handle);
    var p = panel(handle);
    if (!t || !p) return;
    p.setAttribute('data-open', open ? 'true' : 'false');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function openMenu(handle) {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (openHandle && openHandle !== handle) setOpen(openHandle, false);
    openHandle = handle;
    setOpen(handle, true);
  }

  function closeAll(immediate) {
    if (designSelected && !immediate) return;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    var doClose = function () {
      if (openHandle) setOpen(openHandle, false);
      openHandle = null;
    };
    if (immediate) doClose();
    else closeTimer = setTimeout(doClose, CLOSE_DELAY);
  }

  function init() {
    var h = document.querySelector('[data-nv-header]');
    if (!h) return;
    header = h;
    openHandle = null;
    if (h.hasAttribute('data-nv-menu-init')) return;
    h.setAttribute('data-nv-menu-init', '');

    h.querySelectorAll('[data-nv-mega-trigger]').forEach(function (t) {
      var handle = t.getAttribute('data-nv-mega-trigger');
      t.addEventListener('mouseenter', function () { openMenu(handle); });
      t.addEventListener('mouseleave', function () { closeAll(false); });
      t.addEventListener('focus', function () { openMenu(handle); });
    });

    h.querySelectorAll('[data-nv-mega]').forEach(function (p) {
      var handle = p.getAttribute('data-nv-mega');
      p.addEventListener('mouseenter', function () { openMenu(handle); });
      p.addEventListener('mouseleave', function () { closeAll(false); });
    });

    syncScrolled();
  }

  /* Transparent-at-top header: solid once the page is scrolled. */
  function syncScrolled() {
    if (header && header.hasAttribute('data-nv-transparent')) {
      header.toggleAttribute('data-nv-scrolled', window.scrollY > 16);
    }
  }
  window.addEventListener('scroll', syncScrolled, { passive: true });

  /* Document-level listeners registered once; they read the module state. */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openHandle) {
      var t = trigger(openHandle);
      designSelected = false;
      closeAll(true);
      if (t) t.focus();
    }
  });

  document.addEventListener('click', function (e) {
    if (openHandle && header && !header.contains(e.target)) closeAll(true);
  });

  /* Keep panels open while tabbing through them; close when focus leaves. */
  document.addEventListener('focusin', function (e) {
    if (openHandle && header && !header.contains(e.target)) closeAll(true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  /* Theme editor: keep a panel open while its block is selected. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (e) {
      var p = e.target && e.target.closest && e.target.closest('[data-nv-mega]');
      if (!p) return;
      init();
      designSelected = true;
      openMenu(p.getAttribute('data-nv-mega'));
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (!(e.target && e.target.closest && e.target.closest('[data-nv-mega]'))) return;
      designSelected = false;
      closeAll(true);
    });
  }
})();
